import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Logger } from "../../infra/logger/logger";
import timesheetReportRepository from "infra/repositories/timesheet-report-repository";
import { BaseInputFilter } from "domain/models/base-input-filter";

export const useTimesheetReportsByEmployee = (
  id?: string,
  filter?: BaseInputFilter
) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["timesheetReport", id],
    queryFn: async () => {
      try {
        if (!id) throw new Error("Timesheet ID inválido");
        const result =
          await timesheetReportRepository.getTimesheetReportByEmployee(
            id,
            filter
          );

        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: 0,
  });
};

export const useTimesheetReportsAllEmployee = (
  month?: string,
  year?: string,
  filter?: BaseInputFilter,
  enabled: boolean = true
) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["timesheetReport", month, year, filter?.limit],
    queryFn: async () => {
      try {
        if (!month) throw new Error("Timesheet month inválido");
        if (!year) throw new Error("Timesheet year inválido");
        const result =
          await timesheetReportRepository.getTimesheetReportAllEmployees(
            month,
            year,
            filter
          );

        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: 0,
    enabled: enabled
  });
};
